import * as React from 'react'

import { Box, List, Skeleton } from '@factorialco/deprecated-design-system'

export const LoadingSkeleton = () => {
  return (
    <Box width="full">
      <List>
        {[...Array(5)].map((key) => (
          <List.Item key={key}>
            <Box flexDirection="row" paddingY="s8" gap="s24" alignItems="center" width="full">
              <Skeleton width="s32" height="s32" isLoading />
              <Box minWidth="s0">
                <Box padding="s2">
                  <Skeleton width="s200" height="s16" isLoading />
                </Box>
                <Box padding="s2">
                  <Skeleton width="s300" height="s16" isLoading />
                </Box>
                <Box padding="s2">
                  <Skeleton width="s200" height="s16" isLoading />
                </Box>
              </Box>
            </Box>
          </List.Item>
        ))}
      </List>
    </Box>
  )
}
